<h5 class="plan-name">{{ planLabel }}</h5>
<a
  color="warn"
  class="choose-plan-button"
  mat-flat-button
  (click)="choosePlan(plan, $event)"
  >Select plan</a
>
